import { InputNumber, Select } from 'antd';
import { SCHEDULE_UNITS } from 'src/_shared/services/claus/constants';

// Sync frequency + optional lookback as inline word-runs ("every [1] [day(s)]"). Lookback is only
// offered when the template supports it and the integration is job/candidate. serde.validateSchedule
// enforces lookback >= frequency at save time.
export default function ScheduleSection({ schedule, onChange, showLookback }) {
	const s = schedule || { frequency: 1, unit: 'hour' };
	const set = (partial) => onChange({ ...s, ...partial });

	return (
		<>
			<div className="ei-fgrid">
				<div className="ei-fitem is-narrow">
					<span className="ei-flabel">
						Sync frequency <span className="ei-field-req">*</span>
					</span>
					<div className="ei-frow">
						<span className="ei-fword">every</span>
						<InputNumber min={1} value={s.frequency} onChange={(v) => set({ frequency: v })} style={{ width: 80 }} />
						<Select
							value={s.unit}
							onChange={(v) => set({ unit: v })}
							options={SCHEDULE_UNITS}
							style={{ width: 150 }}
						/>
					</div>
				</div>

				{showLookback && (
					<div className="ei-fitem is-narrow">
						<span className="ei-flabel">Lookback period</span>
						<div className="ei-frow">
							<span className="ei-fword">look back</span>
							<InputNumber
								min={1}
								value={s.lookbackPeriod}
								onChange={(v) => set({ lookbackPeriod: v })}
								style={{ width: 80 }}
							/>
							<Select
								allowClear
								placeholder="unit"
								value={s.lookbackPeriodUnit}
								onChange={(v) => set({ lookbackPeriodUnit: v })}
								options={SCHEDULE_UNITS}
								style={{ width: 150 }}
							/>
						</div>
					</div>
				)}
			</div>

			{showLookback && (
				<p className="ei-fhelp">
					How far back to fetch on each sync. Must be at least as long as the sync frequency. Leave blank for none.
				</p>
			)}
		</>
	);
}
